import React from 'react';
import { connect } from 'react-redux';

import { Sanitizer } from 'acq-components/lib/base-components/Sanitizer/Sanitizer';

import { isGCSMember } from 'src/universal/redux/cardMemberInfo';
import {
  getPropsectFooterLegalCopy,
  getCmFooterLegalCopy
} from 'page_modules/business-vac/redux/mainPageData';

import styles from './index.scss?modules';

const FooterLegalCopy = ({
  isGCSMember,
  prospectFooterLegalCopy,
  cmFooterLegalCopy
}) => {
  const legalCopy = isGCSMember
    ? {
        ...prospectFooterLegalCopy,
        content: [...cmFooterLegalCopy.content, ...prospectFooterLegalCopy.content]
      }
    : prospectFooterLegalCopy;
  const { header, content } = legalCopy;
  return (
    <div className={styles.container}>
      <article className={styles.article}>
        <section className={styles.section}>
          <Sanitizer
            Component="div"
            safelySetInnerHTML={header}
            className={styles.header}
          />
          {content.map((item, i) => {
            const descriptions = Array.isArray(item.description)
              ? item.description.map(desc => `<p>${desc}</p>`).join('')
              : `<p>${item.description}</p>`;
            return (
              <div key={i} className={styles.legalCopyBlock}>
                <Sanitizer safelySetInnerHTML={item.header} />
                <Sanitizer safelySetInnerHTML={descriptions} />
              </div>
            );
          })}
        </section>
      </article>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    isGCSMember: isGCSMember(state),
    prospectFooterLegalCopy: getPropsectFooterLegalCopy(state),
    cmFooterLegalCopy: getCmFooterLegalCopy(state)
  };
};

export default connect(mapStateToProps)(FooterLegalCopy);
